export function useKissmetrics () {
  const config = useRuntimeConfig()
  const tech = useTech()
  const { $api } = useNuxtApp()

  const isEnabled = computed(() => !!config.public.KISSMETRICS_TOKEN)
  const isProduction = config.public.ENVIRONMENT_NAME === 'production'

  const identity = useCookie('kissmetrics_identity')
  const isAnonymousIdentity = computed(() => identity.value.startsWith('anonymous_'))
  const isIdentified = computed(() => !!identity.value)

  const user = useUser()
  const trackingUrl = config.public.APP_ROOT + '/api/track'

  if (!isEnabled.value || !isIdentified.value) {
    console.log(config.public.KISSMETRICS_TOKEN)
    console.info('KISSMETRICS_TOKEN not defined')
  }

  function generateAnonymousId () {
    return 'anonymous_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  }

  async function identify () {
    if (!isEnabled.value || !isIdentified.value) return

    try {
      if (user.isGuest) {
        if (!isProduction) console.info('ℹ️ Kissmetrics - identify guest')
        if (!isAnonymousIdentity.value) {
          identity.value = generateAnonymousId()
        }
      } else {
        if (!isProduction) console.info('ℹ️ Kissmetrics - identify user', { user: user.data })

        if (isAnonymousIdentity.value) {
          await alias(identity.value, user.data.id)
        }
        identity.value = user.data.id
      }
    } catch (e) {
      console.error(new Error('Error sending the identify event'))
    }
  }

  async function track (event, properties = {}) {
    if (!isEnabled.value || !isIdentified.value) return
    if (!isProduction) console.info('ℹ️ Kissmetrics - track', { event, properties })

    try {
      await identify()
      const resp = await $api.post(trackingUrl, {
        action: 'record',
        identity: identity.value,
        eventName: event,
        properties
      })

      console.log({ resp })
      return resp
    } catch (e) {
      console.error(new Error('Error sending the track event'))
    }
  }

  async function setPeopleProperties (properties) {
    if (!isEnabled.value || !isIdentified.value) return
    if (!isProduction) console.info('ℹ️ Kissmetrics - setPeopleProperties', { properties })

    try {
      await identify()
      const resp = await $api.post(trackingUrl, {
        action: 'set',
        identity: identity.value,
        properties
      })

      return resp
    } catch (e) {
      console.error(new Error('Error sending the setPeopleProperties event'))
    }
  }

  async function alias (oldId, newId) {
    if (!isEnabled.value || !isIdentified.value) return
    if (!isProduction) console.info('ℹ️ Kissmetrics - alias', { oldId, newId })

    try {
      await $api.post(trackingUrl, {
        action: 'alias',
        identity: oldId,
        alias: newId
      })
    } catch (e) {
      console.error(new Error('Error sending the alias event'))
    }
  }

  async function clearIdentity () {
    identity.value = generateAnonymousId()
  }

  function trackLinkClick (payload) {
    if (payload.name === 'Pricing') {
      track('pricing_clicked', {
        tech: payload.tech || tech?.id
      })
    }
  }

  return {
    identity,
    identify,

    clearIdentity,
    alias,

    track,
    trackLinkClick,
    setPeopleProperties
  }
}
